import React, { useMemo } from 'react';

const BrandsLegend = ({ brandsData }) => {
    const legendItems = useMemo(() => {
        const items =
            brandsData
                ?.reduce((acc, brand) => {
                    const normalizedName = brand.Name.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
                    const firstChar = /^[A-Za-z]/.test(normalizedName[0]) ? normalizedName[0].toUpperCase() : '#';
                    if (!acc.includes(firstChar)) {
                        acc.push(firstChar);
                    }
                    return acc;
                }, [])
                .sort() || [];

        const hashIndex = items.indexOf('#');
        if (hashIndex !== -1) {
            items.splice(hashIndex, 1);
            items.push('#');
        }

        return items;
    }, [brandsData]);

    const handleClick = (item) => {
        const element = document.getElementById(`group-${item}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="flex w-full flex-wrap justify-start pb-8 lg:justify-between">
            {legendItems.map((item) => (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                <div
                    key={item}
                    className="m-1 mx-2.5 flex-none basis-[5%] cursor-pointer text-center text-xl font-semibold md:basis-[4%] lg:flex-auto lg:flex-grow lg:basis-auto"
                    onClick={() => handleClick(item)}
                >
                    {item}
                </div>
            ))}
        </div>
    );
};

export default BrandsLegend;
